import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import * as DataList from 'components/DataList';
import PaymentMethodModal from 'components/PaymentMethod/PaymentMethodModal';

// Layout shared by the list and its loading skeleton (pages/payment_methods/index.js).
export const PAYMENT_METHOD_COLUMNS = [
  { area: 'name', label: 'Payment method', width: 'minmax(200px, 1.6fr)', bone: 'single' },
  { area: 'quickbooks', label: 'QuickBooks', width: 'minmax(160px, 1fr)', bone: 'pill', icon: 'link' },
  { area: 'actions', label: '', width: '48px', bone: 'none' },
];

export const PAYMENT_METHOD_CARDS = {
  columns: 'minmax(0, 1fr) auto',
  areas: ['name actions', 'quickbooks quickbooks'],
};

export const PAYMENT_METHOD_MIN_TABLE_WIDTH = 440;

// The payment methods list (Settings > Payment methods): name and whether it's
// matched to a QuickBooks payment method; edit opens the payment method panel.
@inject('paymentMethodStore', 'quickbooksStore') @observer
class PaymentMethodTable extends Component {
  @observable isPaymentMethodDialogVisible = false;

  openEdit(method) {
    this.props.paymentMethodStore.paymentMethod.object = method.attributes;
    this.isPaymentMethodDialogVisible = true;
    this.props.quickbooksStore.loadQuickbooksPaymentMethods();
  }

  render() {
    const { objects } = this.props.paymentMethodStore.paymentMethods;
    if (objects.length === 0) {
      return (
        <DataList.Empty
          noun="payment methods"
          title="No payment methods yet"
          message="Payment methods you record payments with, like cash or cheque, show up here."
        />
      );
    }
    return (
      <React.Fragment>
        <DataList.List
          columns={PAYMENT_METHOD_COLUMNS}
          cards={PAYMENT_METHOD_CARDS}
          minTableWidth={PAYMENT_METHOD_MIN_TABLE_WIDTH}
          total={objects.length}
          noun="payment methods"
        >
          {objects.map((method) => (
            <DataList.Row key={method.id}>
              <DataList.Cell area="name">
                <DataList.Lines primary={method.attributes.name} />
              </DataList.Cell>
              <DataList.Cell area="quickbooks">
                {method.attributes.quickbooks_payment_method_id
                  ? <DataList.Pill tone="green" icon="tick">Linked</DataList.Pill>
                  : <DataList.Muted>Not linked</DataList.Muted>}
              </DataList.Cell>
              <DataList.Cell area="actions">
                <DataList.Actions
                  items={[{ icon: 'edit', label: `Edit ${method.attributes.name}`, onClick: () => this.openEdit(method) }]}
                />
              </DataList.Cell>
            </DataList.Row>
          ))}
        </DataList.List>
        <PaymentMethodModal
          isOpen={this.isPaymentMethodDialogVisible}
          title="Update Payment Method"
          edit={true}
          onClose={() => { this.isPaymentMethodDialogVisible = false; }}
          onSuccess={() => { this.isPaymentMethodDialogVisible = false; }}
        />
      </React.Fragment>
    );
  }
}

export default PaymentMethodTable;
